import { render } from "./CallenderNew.vue?vue&type=template&id=72d1c47e"
import script from "./CallenderNew.vue?vue&type=script&lang=js"
export * from "./CallenderNew.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__